import dataTestids from '../constants/test-ids';
import BCorp from '../svg/BCorp';
import FlexibleLink from '../util/FlexibleLink';
import LinkedInButton from './LinkedInButton';
import { MovingWorldsBannerLogo } from './MovingWorldsLogo';
import YouTubeButton from './YouTubeButton';

/** Bottom-most gray and white footer areas at the bottom of every page */
const PageFooter = () => {
  return (
    <div className='border-gray-100 border-t-2'>
      {/* Gray link panel */}
      <div className='px-4 md:px-10 py-6 bg-gray-50 flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-left gap-8 font-bold text-brand-500'>
        <div className='w-[234px]'>
          {' '}
          {/* Lazy fix for bad SVG sizing; need to re-export the SVG */}
          <div>
            <a
              href={import.meta.env.VITE_LEGACY_APP_URL}
              data-testid={dataTestids.LAYOUT.FOOTER.LOGO}
            >
              <MovingWorldsBannerLogo />
            </a>
          </div>
        </div>
        <FlexibleLink href='/about' type='legacy'>
          About
        </FlexibleLink>
        <FlexibleLink href='/careers' type='legacy'>
          Careers
        </FlexibleLink>
        <FlexibleLink href='/transform' type='legacy'>
          TRANSFORM Support Hub
        </FlexibleLink>
        <FlexibleLink
          href='https://zsupport.movingworlds.org/portal/en/kb/movingworlds-faqs'
          type='external'
          newTab={false}
        >
          Frequently Asked Questions
        </FlexibleLink>
        <FlexibleLink href='https://blog.movingworlds.org' type='external' newTab={false}>
          Blog
        </FlexibleLink>
        <FlexibleLink href='/contact-form-details?no_cache=1' type='legacy'>
          Contact Us
        </FlexibleLink>
        <div className='fill-gray-50 flex flex-inline gap-8'>
          <YouTubeButton />
          <LinkedInButton />
        </div>
      </div>
      {/* Copyright panel */}
      <div className='my-4 px-4 md:px-10 pt-6 pb-24 flex gap-4 text-sm blue-links'>
        <div>
          © 2024{' '}
          <FlexibleLink href='/' type='legacy'>
            MovingWorlds
          </FlexibleLink>
          . All rights reserved.
        </div>
        <FlexibleLink href='/terms-of-use' type='legacy' newTab>
          Terms of Use
        </FlexibleLink>
        <FlexibleLink href='/privacy-policy' type='legacy' newTab>
          Privacy Policy
        </FlexibleLink>
        <div className='ml-auto w-[43px] h-[72px] fill-gray-500'>
          <BCorp />
        </div>
      </div>
    </div>
  );
};

export default PageFooter;
